import { QueryClient } from "@tanstack/react-query";
// Query client configured for Texas Showdown API
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 1000 * 60 * 5, // 5 minutes
            refetchOnWindowFocus: false,
            retry: 2, // Retry failed requests twice
        },
    },
});
